export const FormText = {
  NAME_REQUIRED: 'Adınızı girmelisiniz.',
  SURNAME_REQUIRED: 'Soyadınızı girmelisiniz.',
  EMAIL_REQUIRED: 'E-posta girmelisiniz.',
  PASSWORD_REQUIRED: 'Parolanızı girmelisiniz.',
  PASSWORD_MIN: 'Parolanızı en az 6 karakter olmalıdır.',
  REQUIRED: 'Bu alan zorunludur.',
  PHONE_LEN: 'Telefon numaranız 11 haneden oluşmalıdır.',
  PHONE_NUMBER: 'Telefon numaranız sadece sayı olmalıdır.',
};
